export const validateSimCard = (values) => {
  const errors = {};

  // Sim validations
  if (!values.sim || values.sim.trim() === "") {
    errors.sim = "validation_required_field";
  }

  if (values.sim && values.sim.length !== 20) {
    errors.sim = "validation_sim_length";
  }

  // Phone number validation
  if (!values.phonenumber || values.phonenumber.trim() === "") {
    errors.phonenumber = "validation_required_field";
  } else if (!/^\d+$/.test(values.phonenumber)) {
    errors.phonenumber = "validation_phone_number_numeric";
  } else if (values.phonenumber.length < 10 || values.phonenumber.length > 15) {
    errors.phonenumber = "validation_phone_number_length";
  } else if (
    values.cardname.startsWith("Vodafone") &&
    !(values.phonenumber.startsWith("3670") || values.phonenumber.startsWith("3631"))
  ) {
    errors.phonenumber = "validation_vodafone_phone_number";
  } else if (!/^\d+$/.test(values.phonenumber)) {
    errors.phonenumber = "validation_phone_number_numeric";
  } else if (
    (values.phonenumber.startsWith("3670") || values.phonenumber.startsWith("3631")) &&
    !values.cardname.startsWith("Vodafone")
  ) {
    errors.phonenumber = "validation_vodafone_phone_number";
  }

  // PIN validation
  if (!values.pin || values.pin.trim() === "") {
    errors.pin = "validation_required_field";
  } else if (values.pin.length !== 4) {
    errors.pin = "validation_pin_length";
  } else if (!/^\d+$/.test(values.pin)) {
    errors.pin = "validation_pin_numeric";
  } else if (values.pin === values.pin2) {
    errors.pin = "validation_pin_equal_pin2";
  }
  // PIN2 validation
  if (values.pin2 && values.pin2.trim() !== "") {
    if (values.pin2.length !== 4) {
      errors.pin2 = "validation_pin2_length";
    } else if (!/^\d+$/.test(values.pin2)) {
      errors.pin2 = "validation_pin2_numeric";
    } else if (values.pin2 === values.pin) {
      errors.pin2 = "validation_pin_equal_pin2";
    }
  }

  // PUK validation
  if (!values.puk || values.puk.trim() === "") {
    errors.puk = "validation_required_field";
  } else if (values.puk.length !== 8) {
    errors.puk = "validation_puk_length";
  } else if (!/^\d+$/.test(values.puk)) {
    errors.puk = "validation_puk_numeric";
  } else if (values.puk === values.puk2) {
    errors.puk = "validation_puk_equal_puk2";
  }

  // PUK2 validation
  if (values.puk2 && values.puk2.trim() !== "") {
    if (values.puk2.length !== 8) {
      errors.puk2 = "validation_puk2_length";
    } else if (!/^\d+$/.test(values.puk2)) {
      errors.puk2 = "validation_puk2_numeric";
    } else if (values.puk2 === values.puk) {
      errors.puk2 = "validation_puk_equal_puk2";
    }
  }

  // Card name validation
  if (!values.cardname || values.cardname.trim() === "") {
    errors.cardname = "validation_required_field";
  } else if (values.cardname.length > 25) {
    errors.cardname = "validation_cardname_length";
  } else if (!/^[a-zA-Z0-9\s]+$/.test(values.cardname)) {
    errors.cardname = "validation_cardname_alphanumeric";
  } else if (
    values.phonenumber.startsWith("3670") &&
    !values.cardname.startsWith("Vodafone")
  ) {
    errors.cardname = "validation_vodafone_cardname";
  }

  return errors;
};
